/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import styles from './RightColumnSkeleton.module.scss';
import { FlexGrid } from '@/components/FlexGrid/FlexGrid';
import { Button, Divider, Skeleton } from '@az/starc-ui';
import { useLabels } from '@/hooks/useLabels';

export default function RightColumnSkeleton() {
  const labels = useLabels({ addToCart: 'button_ProductDisplayPage_body_AddToCart' });
  return (
    <>
      <div className={styles.container} data-testid="product-availability-info-right-skeleton">
        <FlexGrid flexDirection="column" gap={4} className={styles.rightContainer}>
          <FlexGrid flexDirection="column" gap={4}>
            <FlexGrid flexDirection="column" gap={1}>
              <FlexGrid
                flexDirection="row"
                className={styles.priceContainer}
                justifyContent="space-between"
              >
                <Skeleton width="45%" height="31px" className={styles.price} />
                <Skeleton width="20%" height="31px" className={styles.rightSection} />
              </FlexGrid>
              <FlexGrid className={styles.paypalSection} gap={2}>
                <Skeleton
                  height="16px"
                  width="16px"
                  attributes={{
                    style: { borderRadius: '50%', minHeight: '16px', marginTop: '2px' },
                  }}
                />
                <Skeleton height="19px" width="308px" />
              </FlexGrid>
              <Divider className={styles.firstDivider} />
            </FlexGrid>
            <FlexGrid flexDirection="column" gap={2}>
              <FlexGrid className={styles.pickupOptions} gap={1}>
                <Skeleton width="33%" height="75px" />
                <Skeleton width="33%" height="75px" />
                <Skeleton width="33%" height="75px" />
              </FlexGrid>
              <Skeleton className={styles.pickupLocation} width="45%" height="19px" />
            </FlexGrid>
            <Divider className={styles.secondDivider} />
            <FlexGrid flexDirection="row" gap={4}>
              <Skeleton width="104px" height="54px" borderRadius="small"></Skeleton>
              <Button loading className={styles.ctaButton} variant="primary">
                {labels.addToCart}
              </Button>
            </FlexGrid>
          </FlexGrid>
        </FlexGrid>
      </div>
    </>
  );
}
